import * as S from "@/containers/Project/components/styled";
import { projectMilestoneType } from "@/propTypes";
import { Col, Tooltip } from "antd";
import { bool } from "prop-types";
import { useIntl } from "react-intl";

export const MilestoneAttributeDisplay = ({
  milestone,
  targetDatesRequired,
  skuRequired,
}) => {
  const intl = useIntl();

  const attributes = [];

  if (skuRequired) {
    attributes.push("skuRequired");
  }

  if (targetDatesRequired) {
    attributes.push("targetDatesRequired");
  }

  if (milestone.secureProjectOnCompletion && milestone.shouldCompleteProject) {
    attributes.push("projectCompleteSecure");
  } else if (milestone.shouldCompleteProject) {
    attributes.push("projectComplete");
  }

  return (
    <Col className="pr-1" style={{ display: "flex" }}>
      <S.AttributeRow
        style={{
          width: "60px",
          display: "inline-grid",
          justifyItems: "center",
        }}
      >
        {attributes.map((value) => (
          <Tooltip
            key={value}
            title={intl.formatMessage({
              id: `milestonesList.${value}AttributeTooltip`,
            })}
          >
            {intl.formatMessage({ id: `milestonesList.${value}Attribute` })}
          </Tooltip>
        ))}
      </S.AttributeRow>
    </Col>
  );
};

MilestoneAttributeDisplay.propTypes = {
  milestone: projectMilestoneType.isRequired,
  targetDatesRequired: bool,
  skuRequired: bool,
};
